import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input, forwardRef, NgZone } from '@angular/core';
import { PeoplePickerService } from '../services/people-picker.service';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { PeoplePicker } from '../models/people-picker';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'people-picker',
  templateUrl: './people-picker.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PeoplePickerComponent),
      multi: true
    }
  ]
})

export class PeoplePickerComponent extends BaseTranslation implements OnInit, ControlValueAccessor {
  searchText: string;
  returnedUsers: any[] = [];
  selectedUsers: PeoplePicker[] = [];
  opened: boolean = false;
  sameUserValidation: boolean = false;
  loading: boolean = false;
  // Allow the input to be disabled.
  @Input() disabled = false;

  @ViewChild('searchInput') searchInput: ElementRef;

  constructor(private peoplePickerService: PeoplePickerService, ngZone: NgZone, translateService: TranslateService) {
    super(translateService, ngZone);
  }

  ngOnInit() { }

  startSearch() {

    if (this.searchText.trim() !== "" && this.searchText !== null && this.searchText !== undefined) {

      this.loading = true;
      this.opened = true;
      this.returnedUsers = [];
      this.searchInput.nativeElement.focus();

      this.peoplePickerService.searchSPUsers(this.searchText).subscribe(data => {
        this.returnedUsers = data;
        this.loading = false;
      });

    }

  }

  addUser(newUser) {
    this.clearInput();
    if (!this.selectedUsers.find(user => user.name === newUser.DisplayText)) {
      this.selectedUsers.push({ name: newUser.DisplayText, email: newUser.EntityData.Email, userName: newUser.Key.split("|").length > 1 ? newUser.Key.split("|")[1] : newUser.Key });
      this.sameUserValidation = false;
      this.pick(this.selectedUsers);
    } else {
      this.sameUserValidation = true;
    }
  }

  removeUser(user) {
    this.sameUserValidation = false;

    let filtered = this.selectedUsers.filter((value) => {
      return value.name !== user;
    });

    this.selectedUsers = filtered;
    this.pick(this.selectedUsers);
  }

  clearInput() {
    this.searchText = "";
    this.sameUserValidation = false;
  }

  onBlur() {
    this.returnedUsers = [];
    this.opened = false;
  }

  // Function to call when the people changes.
  onChange = (people: any[]) => { };

  // Function to call when the input is touched.
  onTouched = () => { };

  get value(): PeoplePicker[] {
    return this.selectedUsers;
  }

  pick(people: PeoplePicker[]) {
    if (!this.disabled) {
      this.writeValue(people);
    }
  }


  // Allows Angular to update the model.
  // Update the model and changes needed for the view here.
  writeValue(people: PeoplePicker[]): void {
    this.selectedUsers = people;
    this.onChange(this.value)
  }

  // Allows Angular to register a function to call when the model changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: (people: PeoplePicker[]) => void): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Allows Angular to disable the input.
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


}
